import { render, staticRenderFns } from "./ModuleInfo.vue?vue&type=template&id=55dcd2c3&scoped=true&"
import script from "./ModuleInfo.vue?vue&type=script&lang=js&"
export * from "./ModuleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dcd2c3",
  null
  
)

export default component.exports